module.exports = __webpack_public_path__ + "static/img/cloud-bg.172682f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/cloud-bg.png
// module id = 653
// module chunks = 64